module.exports = "img/checkbox.svg";